import React, { Component } from 'react';
import { notification } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { adminAllUsersListAction,adminUsersStatusAction } from '../../../actions/Admin/Users';
import NavMenu from '../sidebar/navBar';
import SideMenu from '../sidebar/SidebarCustom';
import './../App.css';

class JobSeekersUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            fieldsList: [],
            code: '',
            sizePerPage: 10,
            fieldSelct: '',
            fieldsCount: "",
            currentPage:1,
            userType:"user"
        }
    }

    componentWillMount() {
        let reqObj = {
            "limit": 10,
            "offset": 0,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": "",
            "userType":this.state.userType
        }
        this.props.adminAllUsersListAction(reqObj);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps  && nextProps.userData&& nextProps.userData.data.length > 0) {
            this.setState({
                fieldsCount: nextProps.userData.count,
                fieldsList: nextProps.userData.data

            })
        }

        if(nextProps.userDataStatus&&nextProps.userDataStatus.statusCode===200&&this.state.statusChange===true){
            notification.success({
                message: nextProps.userDataStatus.msg,
                className:'successNotification',
                duration: 3
            });
            this.setState({
                statusChange:false
            })
            this.componentWillMount();
        }
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

   

  sizePerPageListChange(sizePerPage) {
    alert(`sizePerPage: ${sizePerPage}`);
  } 


    StatusBrow(cell, row, rowIndex){
        return(
            <button onClick={this.chnageStatus.bind(this,row,"status")}>{row.status}</button>
        )
    }



    chnageStatus=(data,type,value)=>{
        let reqObj={
            id:data._id
        }
        if(type==="approvedStatus"){
            if(data.approvedStatus==="approve"){
                reqObj.status="unapprove";
            }else{
                reqObj.status="approve";
            }
        }else{
            if(data.status==="active"){
                reqObj.status="inactive"        
            }else{
                reqObj.status="active"        
            }
        }
         this.setState({
            statusChange:true
         })
             console.log("reqObj", reqObj);
        this.props.adminUsersStatusAction(reqObj)

    }

    onPageChange(page, sizePerPage) {
 
        this.setState({
            currentPage:page
        })

        let reqObj = {
            "limit": 10,
            "offset": page-1,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": "",
            "userType":this.state.userType,
        }
        this.props.adminAllUsersListAction(reqObj);
    }

    render() {
        const {fieldsList, currentPage} = this.state;
        var options = {
            onPageChange: this.onPageChange.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            paginationPosition: 'bottom', // default is bottom, top and both is all available
            alwaysShowAllBtns: true,
            page: currentPage,
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', 
        };
  
        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                    <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    <div className="custom-table-wrapper  ">
                        <BootstrapTable data={fieldsList} options={options} remote={true} fetchInfo={{dataTotalSize: this.state.fieldsCount}} pagination> 
                            <TableHeaderColumn hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                            <TableHeaderColumn width='400' tdAttr={{'data-attr':'Name' }} dataField='firstName'>Name</TableHeaderColumn>
                            <TableHeaderColumn width='400' tdAttr={{'data-attr':'Email' }} dataField='email'>Email</TableHeaderColumn>
                            <TableHeaderColumn  tdAttr={{'data-attr':'Status' }} dataField='status' dataFormat={this.StatusBrow.bind(this)}>Status</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div> 
        );
    } 
}

function mapStateToProps(state) {
    return {
        //userCount: state.AdminUsersList.response.count,
        userData: state.AdminUsersList.response.data,
        userDataStatus: state.AdminUsersList.responseStatus
    };
}

export default withRouter(connect(mapStateToProps, {
    adminAllUsersListAction,
    adminUsersStatusAction
})(JobSeekersUser));





// WEBPACK FOOTER //
// ./src/components/Admin/User/JobSeekersUser.js